import type { ScriptName } from '@jetopolis/i18n';

/**
 * Ленивая подгрузка шрифтов по скрипту локали (05 §3, инвариант 11 -
 * всё self-hosted, ни одного запроса к внешним шрифтовым сервисам).
 *
 * Импорты статические строковые литералы: динамический import с переменной
 * бандлер разрешить не может, и файл просто не поедет.
 * Латиница, кириллица и греческий покрыты базовыми шрифтами и грузятся сразу.
 */
const LOADERS: Record<ScriptName, (() => Promise<unknown>) | null> = {
  latin: null,
  greek: null,
  ja: () => import('@fontsource/noto-sans-jp/400.css'),
  ko: () => import('@fontsource/noto-sans-kr/400.css'),
  'zh-hans': () => import('@fontsource/noto-sans-sc/400.css'),
  'zh-hant': () => import('@fontsource/noto-sans-tc/400.css'),
  thai: () => import('@fontsource/noto-sans-thai/400.css'),
  devanagari: () => import('@fontsource/noto-sans-devanagari/400.css'),
  arabic: () => import('@fontsource/noto-sans-arabic/400.css'),
  hebrew: () => import('@fontsource/noto-sans-hebrew/400.css'),
};

const loaded = new Set<ScriptName>();

export async function ensureScriptFont(script: ScriptName): Promise<void> {
  if (loaded.has(script)) return;
  loaded.add(script);
  const loader = LOADERS[script];
  if (!loader) return;
  try {
    await loader();
  } catch (e) {
    // Без шрифта текст покажется системным запасным, но интерфейс жив.
    loaded.delete(script);
    console.error(`[i18n] шрифт для ${script} не загрузился`, e);
  }
}
